import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {Lock} from "../lock.interface";
import {MessageCollection, MessageCollectionRespone, MessageStatistics} from "./api.models";
import {UserStatisticsEndpoint} from "./userStatistics/api.service";
import {Headers, Response} from "@angular/http";

export class MessagesEndpoint extends Request {
    collection(
        page: number,
        perPage: number,
        subject?: string,
        content?: string,
        state?: string,
        sort?: string,
        direction?: string,
        type?: string,
        amount?: number,
        attachment?: string,
        behaviour?: string,
        tags?: string[],
        languageIds?: number[],
        loadMessages?: boolean,
        unlockedRecordsOnly?: boolean
    ): Observable<MessageCollectionRespone> {
        return this.get('/v1/messages', this.createSearch({
            page: page,
            perPage: perPage,
            subject: subject,
            content: content,
            state: state,
            type: type,
            amount: amount,
            attachment: attachment,
            behaviour: behaviour,
            sort: sort,
            direction: direction,
            tags: tags,
            languageIds: languageIds,
            loadMessages: loadMessages,
            unlockedRecordsOnly: unlockedRecordsOnly
        }));
    }

    resource(id: number): Observable<MessageCollection> {
        return this.get('/v1/messages/' + id);
    }

    resourceWithDetails(id: number): Observable<MessageCollection> {
        return this.get('/v1/messages/' + id + '/details');
    }

    store(messageCollection: MessageCollection): Observable<MessageCollection> {
        let data = JSON.parse(JSON.stringify(messageCollection));
        data.metadata.sender = {
            relationshipStatus: data.metadata.sender.relationshipStatus
        };

        return this.put('/v1/messages', data);
    }

    remove(id: number): Observable<boolean> {
        return this.delete('/v1/messages/' + id);
    }

    lock(id: number): Observable<Lock> {
        return this.get('/v1/messages/' + id + '/lock');
    }

    userStatistics(): UserStatisticsEndpoint {
        return new UserStatisticsEndpoint(this.http, this.settings);
    }

    MessageStatistics(
        messageType: string,
        messageTag?: string,
        baseName?: string,
        orderBy?: string,
        sort?: string,
        page?: number,
        perPage?: number,
        direction?: string,
    ): Observable<MessageStatistics> {

        return this.get('/v1/messages/statistics', this.createSearch({
            page: page,
            perPage: perPage,
            baseName: baseName,
            messageTag: messageTag,
            sort: sort,
            direction: direction,
            messageType: messageType,
            orderBy
        }))
    }

    // The statistics export needs to return a .csv file
    // Other responses only support JSON that's why this method works a bit different
    MessageStatisticsExport(
        messageType: string,
        messageTag?: string,
        baseName?: string,
        orderBy?: string,
        sort?: string,
        page?: number,
        perPage?: number,
        direction?: string,
    ): Observable<Response> {
        let headers = new Headers();
        if (this.settings.token) {
            headers.set('Authorization', 'token ' + this.settings.token);
        }

        let params = this.createSearch({
            page: page,
            perPage: perPage,
            baseName: baseName,
            messageTag: messageTag,
            sort: sort,
            direction: direction,
            messageType: messageType,
            orderBy
        });
        return this.http.get(
            this.settings.apiUrl + '/v1/messages/statistics/export',
            {
                params: params,
                headers: headers,
                withCredentials : !!this.settings.token,
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messages/api.service.ts